import React from "react";
import { Clock, XCircle, LogOut, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AccountStatus({ kind }) {
  const { user, logout, checkAuth } = useAuth();
  const pending = kind === "pending";
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid={pending ? "account-pending-screen" : "account-rejected-screen"}>
      <div className="w-full max-w-md text-center">
        <div className={`mx-auto h-16 w-16 rounded-2xl flex items-center justify-center mb-6 ${pending ? "bg-amber-100" : "bg-red-100"}`}>
          {pending ? <Clock className="h-8 w-8 text-amber-600" /> : <XCircle className="h-8 w-8 text-red-600" />}
        </div>
        <h1 className="font-display text-3xl font-extrabold">{pending ? "Awaiting approval" : "Account not approved"}</h1>
        <p className="mt-3 text-muted-foreground">
          {pending
            ? `Thanks${user?.name ? `, ${user.name.split(" ")[0]}` : ""}! Your Greenrgy portal account is pending admin approval. You'll get full access as soon as an administrator approves it.`
            : "Your sign-up request was not approved. If you believe this is a mistake, please contact Greenrgy support."}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          {pending && (
            <Button onClick={checkAuth} className="gap-2" data-testid="pending-refresh-button">
              <RefreshCw className="h-4 w-4" /> Check status
            </Button>
          )}
          <Button variant="outline" onClick={logout} className="gap-2" data-testid="pending-logout-button">
            <LogOut className="h-4 w-4" /> Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
